import React, { Component } from 'react';
import { Avatar, Typography, Card, CardActionArea, Divider } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PhoneIcon from '@material-ui/icons/Phone';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCurrentTab } from './../../../redux/actions/';



class Usuario extends Component {
  state = {
    nome: localStorage.getItem('@webApp/username') || 'Usuário',
    celular: localStorage.getItem('@webApp/usertelefone') || '',
  };

  // Gera as iniciais do nome
  getInitials = (name) => name ? name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() : '';

  render() {
    return (
      <div
        style={{
          background: 'linear-gradient(180deg, #991e25 0%, #b71c1c 40%, #d32f2f 70%, #f8f9fa 100%)',
          minHeight: '100vh',
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'visible', // Mudado para visible
          paddingBottom: '75px', // Espaço para a navegação inferior
          boxSizing: 'border-box'
        }}
      >
        {/* Elementos decorativos de fundo */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.1)',
          animation: 'float 6s ease-in-out infinite'
        }} />
        <div style={{
          position: 'absolute',
          top: '20%',
          left: '-30px',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.08)',
          animation: 'float 4s ease-in-out infinite reverse'
        }} />
        
        {/* Header com informações do usuário */}
        <div style={{
          padding: '60px 20px 40px 20px',
          textAlign: 'center',
          background: 'transparent',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{
            position: 'relative',
            display: 'inline-block',
            marginBottom: 20
          }}>
            <Avatar
              style={{
                width: 120,
                height: 120,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                fontSize: 48,
                fontWeight: 'bold',
                color: '#991e25',
                boxShadow: '0 12px 40px rgba(0,0,0,0.2), 0 0 0 6px rgba(255,255,255,0.1)',
                border: '4px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(10px)',
                margin: '0 auto 20px auto'
              }}
            >
              {this.getInitials(this.state.nome)}
            </Avatar>
            
            {/* Indicador online */}
            <div style={{
              position: 'absolute',
              bottom: 15,
              right: 15,
              width: 24,
              height: 24,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #4caf50 0%, #66bb6a 100%)',
              border: '3px solid #fff',
              boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)'
            }} />
          </div>
          
          <Typography 
            variant="h4" 
            style={{ 
              fontWeight: 800, 
              color: '#fff', 
              marginBottom: 8,
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              letterSpacing: '0.5px'
            }}
          >
            {this.state.nome}
          </Typography>
          
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            background: 'rgba(255,255,255,0.2)',
            padding: '8px 16px',
            borderRadius: 20,
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255,255,255,0.3)'
          }}>
            <PhoneIcon style={{ fontSize: 18, color: '#fff' }} />
            <Typography 
              variant="body1" 
              style={{ 
                color: '#fff', 
                fontWeight: 500,
                textShadow: '0 1px 2px rgba(0,0,0,0.2)'
              }}
            >
              {this.state.celular}
            </Typography>
          </div>
        </div>

        {/* Container principal dos cards */}
        <div style={{
          flex: 1,
          padding: '0 20px 95px 20px',
          background: 'transparent',
          position: 'relative',
          zIndex: 1
        }}>
          {/* Card principal com opções */}
          <Card style={{ 
            borderRadius: 20, 
            boxShadow: '0 12px 40px rgba(0,0,0,0.08)',
            background: '#fff',
            marginTop: 20,
            overflow: 'hidden',
            border: '1px solid rgba(0,0,0,0.02)'
          }}>
            
            {/* Opção: Meus endereços */}
            <CardActionArea
              onClick={() => {
                this.props.history.push({
                  pathname: '/Endereco',
                  state: { quemChamou: 'Carrinho' }
                });
              }}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                padding: '20px 24px',
                transition: 'all 0.3s ease',
                justifyContent: 'space-between'
              }}
              onMouseOver={e => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)';
                e.currentTarget.style.transform = 'translateX(4px)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'translateX(0)';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: 'linear-gradient(135deg, #991e25 0%, #b71c1c 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 16,
                  boxShadow: '0 4px 16px rgba(153, 30, 37, 0.2)'
                }}>
                  <HomeIcon style={{ color: '#fff', fontSize: 24 }} />
                </div>
                <div>
                  <Typography variant="h6" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
                    Meus endereços
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Gerenciar endereços de entrega
                  </Typography>
                </div>
              </div>
              <ArrowForwardIosIcon style={{ color: '#991e25', fontSize: 18 }} />
            </CardActionArea>
            
            <Divider style={{ margin: '0 24px' }} />
            
            {/* Opção: Meus pedidos */}
            <CardActionArea
              onClick={() => {
                this.props.history.push({
                  pathname: '/Pedidos',
                  state: { quemChamou: 'Carrinho' }
                });
              }}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                padding: '20px 24px',
                transition: 'all 0.3s ease',
                justifyContent: 'space-between'
              }}
              onMouseOver={e => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)';
                e.currentTarget.style.transform = 'translateX(4px)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'translateX(0)';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: 'linear-gradient(135deg, #2196f3 0%, #21cbf3 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 16,
                  boxShadow: '0 4px 16px rgba(33, 150, 243, 0.2)'
                }}>
                  <ListAltIcon style={{ color: '#fff', fontSize: 24 }} />
                </div>
                <div>
                  <Typography variant="h6" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
                    Meus pedidos
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Histórico de pedidos realizados
                  </Typography>
                </div>
              </div>
              <ArrowForwardIosIcon style={{ color: '#2196f3', fontSize: 18 }} />
            </CardActionArea>
            
            <Divider style={{ margin: '0 24px' }} />
            
            {/* Opção: Logoff */}
            <CardActionArea
              onClick={() => {
                localStorage.removeItem('@webApp/userid');
                localStorage.removeItem('@webApp/username');
                this.props.history.push({
                  pathname: '/',
                  state: { quemChamou: 'Carrinho' }
                });
              }}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                padding: '20px 24px',
                transition: 'all 0.3s ease',
                justifyContent: 'space-between'
              }}
              onMouseOver={e => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)';
                e.currentTarget.style.transform = 'translateX(4px)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'translateX(0)';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: 'linear-gradient(135deg, #f44336 0%, #e57373 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 16,
                  boxShadow: '0 4px 16px rgba(244, 67, 54, 0.2)'
                }}>
                  <ExitToAppIcon style={{ color: '#fff', fontSize: 24 }} />
                </div>
                <div>
                  <Typography variant="h6" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
                    Sair da conta
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Fazer logout do aplicativo
                  </Typography>
                </div>
              </div>
              <ArrowForwardIosIcon style={{ color: '#f44336', fontSize: 18 }} />
            </CardActionArea>
          </Card>
        </div>

        {/* Animações CSS */}
        <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-20px) rotate(5deg); }
          }
          
          /* Garantir que a navegação inferior apareça em todos os dispositivos */
          @media (max-width: 480px) {
            .user-avatar {
              width: 100px !important;
              height: 100px !important;
              font-size: 40px !important;
            }
            .user-name {
              font-size: 28px !important;
            }
            
            /* Ajustar layout para mobile */
            body {
              padding-bottom: 75px !important;
            }
          }
          
          @media (max-width: 768px) {
            /* Garantir espaço para navegação em tablets */
            body {
              padding-bottom: 75px !important;
            }
          }
          
          @media (min-width: 769px) {
            /* Desktop - garantir navegação visível */
            body {
              padding-bottom: 75px !important;
            }
          }
          
          /* Forçar navegação fixa na parte inferior */
          html, body {
            overflow-x: hidden;
          }
        `}</style>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentTab: state.CurrentTabReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setCurrentTab }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Usuario);
